"use client";
export { GlobalError as default } from "@janeway/gui-elements";
